(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bolsa-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.blReady) return;
      root.dataset.blReady = '1';

      var currency = root.dataset.currency || 'EUR';
      var formatter;
      try {
        formatter = new Intl.NumberFormat('es-ES', { style: 'currency', currency: currency });
      } catch (e) {
        formatter = null;
      }

      function format(cents) {
        return formatter ? formatter.format(cents / 100) : (cents / 100).toFixed(2).replace('.', ',') + ' €';
      }

      /* Variantes */
      var variantsEl = root.querySelector('[data-bl-variants]');
      var idInput = root.querySelector('[data-bl-variant-id]');
      if (variantsEl && idInput) {
        var variants = [];
        try {
          variants = JSON.parse(variantsEl.textContent);
        } catch (e) {}
        var groups = root.querySelectorAll('[data-bl-option]');

        var update = function () {
          var chosen = [];
          groups.forEach(function (group) {
            var checked = group.querySelector('input:checked');
            chosen.push(checked ? checked.value : null);
          });
          var match = variants.find(function (v) {
            return chosen.every(function (val, i) {
              return val === null || v.options[i] === val;
            });
          });
          if (!match) return;

          idInput.value = match.id;
          root.querySelectorAll('[data-bl-price]').forEach(function (el) {
            el.textContent = format(match.price);
          });
          root.querySelectorAll('[data-bl-cta]').forEach(function (btn) {
            var text = btn.querySelector('[data-bl-cta-text]');
            btn.disabled = !match.available;
            if (text) text.textContent = match.available ? btn.dataset.label : 'AGOTADO';
          });
        };

        groups.forEach(function (group) {
          group.addEventListener('change', update);
        });
      }

      /* Barra fija: aparece cuando el CTA del hero sale de la pantalla */
      var sticky = root.querySelector('[data-bl-sticky]');
      var heroCta = root.querySelector('[data-bl-hero-cta]');
      if (sticky && heroCta && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var out = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', out);
            sticky.setAttribute('aria-hidden', out ? 'false' : 'true');
          });
        });
        observer.observe(heroCta);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-bl-root]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
